import { OverlappingEmpForm } from '~/features/OverlappingEmploymentDialog/hooks/useOverlappingEmploymentForm';
import { fetchFromOldApi } from '~/services/Http';

export const saveWorkingHours = async (
  employeeId: number,
  employmentId: number,
  form: OverlappingEmpForm,
) => {
  const url = `/json/employee/${employeeId}/employment/${employmentId}/workinghours`;
  const payload = form.overlappingEmployment.currentWorkingHours;
  payload.fWorkHoursStartDate =
    form.overlappingEmployment.basicData.fEmplDateStart;
  return await fetchFromOldApi(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((r) => r.json())
    .catch((e) => {
      console.log('saveWorkingHours', e);
    });
};
